/**
 * Controls browser back navigation on PDP: when the user arrived via a color swatch link,
 * intercepts the Back button and redirects to the PLP URL. Otherwise Back uses normal history.
 */
// TODO: There is an issue the browser caching when using back navigation. The script below is a workaround to make sure the back navigation works asap.
// We will have to continue the investigation on "src/js/objects/product/pdp-navigation.js" when we have time.
(function () {
    function clearRedirectState() {
      window.sessionStorage.removeItem('PDP_LAST_VISITED_PLP_URL');
      window.sessionStorage.removeItem('PDP_COLOR_SWATCH_SOURCE_URL');
    }
  
    function controlPdpBrowserBackNavigation() {
      const referrer = document.referrer;
      const referrerIsCollection = referrer && referrer.includes('/collections/');
      if (referrerIsCollection) {
        window.sessionStorage.setItem('PDP_LAST_VISITED_PLP_URL', referrer);
      }
  
      const sourceUrl = window.sessionStorage.getItem('PDP_COLOR_SWATCH_SOURCE_URL');
      const collectionUrl = window.sessionStorage.getItem('PDP_LAST_VISITED_PLP_URL');
  
      const currentPageIsColorSwatchSource = sourceUrl === window.location.href;
      if (
        collectionUrl &&
        currentPageIsColorSwatchSource
      ) {
        clearRedirectState();
        localStorage.setItem('PLP_RESTORE_SCROLL', '1');
        window.location.href = collectionUrl;
        return;
      }
    }
  
    controlPdpBrowserBackNavigation();
  })();
